module.exports = "/images/Latvia.png?5268c3135c64ec77667c9997c5e83886";